
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34417',
  depVersions: {
  "documents-public-ui": "static-1.34417",
  "client-types": "static-1.464",
  "documents-lib": "static-1.34422",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2098",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5558",
  "hs-test-utils": "static-1.7981",
  "hub-http": "static-1.6187",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11427",
  "I18n": "static-7.1615",
  "jasmine-immutable": "static-1.2985",
  "jasmine-runner": "static-1.6433",
  "lodash": "static-1.3",
  "quartz": "static-1.6973",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16634",
  "reporting-data": "static-1.67373",
  "reporting-testing-lib": "static-1.9306",
  "reporting-visualizations": "static-1.59449",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4734",
  "webpack-env": "static-1.54",
  "atom": "static-1.5038",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2464",
  "classnames": "static-2.10",
  "cssUtils": "static-1.782",
  "customer-data-filters-ui": "static-1.39629",
  "customer-data-objects": "static-1.7629",
  "customer-data-property-utils": "static-1.8049",
  "data-fetching-client": "static-1.9638",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4483",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85740",
  "FormUrlGenerator": "static-2.4685",
  "foundations-components": "static-1.7857",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11735",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7124",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3812",
  "property-translator": "static-1.5367",
  "quartz-config": "static-1.751",
  "quartz-core": "static-1.6192",
  "quick-fetch": "static-1.3887",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5315",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8135",
  "reference-resolvers-lite": "static-1.8060",
  "report-customization-components": "static-1.13058",
  "reporting-enablement": "static-1.22785",
  "reporting-reports": "static-1.67051",
  "reporting-snowflake": "static-1.55991",
  "reporting-ui-components": "static-2.64644",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4617",
  "sales-content-partitioning": "static-1.8904",
  "SalesContentIndexUI": "static-3.9187",
  "sanitize": "static-1.4438",
  "sanitize-text": "static-1.8109",
  "self-service-api": "static-1.10212",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1712",
  "signup-constants": "static-1.18779",
  "signup-ui-lego-core": "static-1.20789",
  "signup-ui-url-generator": "static-2.8007",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4731",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10953",
  "ui-addon-i18n": "static-1.11115",
  "ui-addon-react-router-dom": "static-1.9510",
  "ui-addon-upgrades": "static-9.17935",
  "ui-asset-management-lib": "static-1.10976",
  "ui-images": "static-2.1143",
  "UIComponents": "static-3.8374",
  "usage-tracker": "static-1.7303",
  "usage-tracker-container": "static-1.7293",
  "usage-tracker-core": "static-1.7153",
  "usage-tracker-public": "static-1.7114",
  "viral-links-lib": "static-1.7021",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3374",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3250",
  "quartz-webpack": "static-1.3197",
  "ai-components-ui-library": "static-1.8843",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4823",
  "foundations-theming": "static-1.4382",
  "quartz-auth": "static-1.648",
  "ui-business-units-lib": "static-1.9015",
  "usage-tracker-session-replay": "static-1.4989",
  "foundations-theming-base": "static-1.3367",
  "HeadJS": "static-2.742",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3092",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.55",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4290",
  "csstype": "static-1.50",
  "quartz-head": "static-1.638",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7894",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3561",
  "persist-promise": "static-1.3667",
  "quartz-i18n": "static-1.648",
  "reporting-client-types": "static-1.2481",
  "foundations-components-legacy": "static-1.882",
  "hs-story-utils": "static-1.9394",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9873",
  "hubspotter-http": "static-1.4623",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7215",
  "crm-message-bus": "static-1.42893",
  "customer-data-filters-ui-msw-helpers": "static-1.22064",
  "customer-data-objects-ui-components": "static-1.12991",
  "customer-data-reference-ui-components": "static-1.13126",
  "customer-data-ui-utilities": "static-1.9793",
  "framework-builder-read-service-client": "static-1.3980",
  "framework-data-schema-quick-fetch": "static-1.6751",
  "framework-data-schema-resolvers": "static-1.6846",
  "inbound-db-properties-service-client": "static-1.3811",
  "multi-account-reference-resolvers": "static-1.944",
  "onboarding-tours": "static-1.16527",
  "reporting-datasets-permissions-lib": "static-1.13566",
  "ui-addon-teams": "static-1.21498",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68253",
  "customer-data-properties": "static-1.51421",
  "forms-ai-lib": "static-1.4258",
  "forms-utils-lib": "static-1.12509",
  "foundations-components-test-utils": "static-1.5340",
  "react-dnd-compat": "static-1.4585",
  "react-tinymce": "static-1.55135",
  "tinymce-config": "static-2.54261",
  "ui-gdpr-components": "static-1.10314",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4126",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1744",
  "ui-fonts": "static-1.689",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.403",
  "quartz-test": "static-1.648",
  "quartz-tracking": "static-1.352",
  "batch-promise": "static-1.1510",
  "external-options-client-types": "static-1.4129",
  "react-colorpicker": "static-2.10176",
  "copilot-toolkit": "static-1.11036",
  "data-quality-ui-library": "static-1.12875",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6428",
  "reporting-action-components": "static-1.41196",
  "reporting-filters": "static-1.238",
  "reporting-insights-lib": "static-1.1634",
  "reporting-plugins": "static-1.10255",
  "ui-addon-draggable-compat": "static-2.4221",
  "ui-addon-opt": "static-4.8336",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25269",
  "hubspot-apollo-client": "static-1.4842",
  "bend-plugin-chirp-manifest": "static-1.27",
  "chirp-fetch": "static-1.1851",
  "sales-templates-service-types-lib": "static-1.4139",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5816",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4049",
  "nested-table": "static-1.191",
  "timezone-utils": "static-2.5211",
  "bender-build-tools": "static-1.3151",
  "chatspot-core": "static-1.21118",
  "bend-plugin-foundations-theming": "static-1.2865",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9871",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3768",
  "crm-pipelines-api-client-types": "static-1.4113",
  "multi-currency-client-types": "static-1.3662",
  "getting-started-shared-tasks": "static-1.18400",
  "growth-data-modal": "static-1.5369",
  "growth-onboarding-confetti": "static-1.3033",
  "growth-onboarding-next-action-utils": "static-1.1816",
  "navigation-components": "static-1.17909",
  "onboarding-tours-client": "static-1.4741",
  "onboarding-tours-utils": "static-1.593",
  "ui-shepherd-react": "static-3.10116",
  "ui-shepherd-tracker": "static-1.7497",
  "ui-universal-auth": "static-1.8929",
  "user-context": "static-1.5069",
  "cms-field-types": "static-1.4778",
  "content-icons-ui": "static-1.2216",
  "integrations-lib": "static-1.16004",
  "calling-global-api": "static-1.64384",
  "calling-internal-common": "static-1.31268",
  "calling-lifecycle-internal": "static-1.65766",
  "calling-lifecycle-messages": "static-1.58060",
  "commerce-products-lib": "static-1.9406",
  "crm-links": "static-1.6250",
  "customer-data-properties-shared-msw-handlers": "static-1.9200",
  "file-manager-components": "static-1.23514",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.115",
  "inbounddb-objects-service-types": "static-1.4194",
  "meetings-icalendar-utils-lib": "static-1.598",
  "object-builder-ui-client": "static-1.48613",
  "pipeline-validation-client-types": "static-1.3936",
  "property-value-citations": "static-1.2035",
  "pulse": "static-1.526",
  "smart-property-lib": "static-1.6733",
  "tiered-pricing": "static-1.1126",
  "ui-addon-iframeable": "static-1.9023",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19767",
  "tinymce-themes": "static-1.56231",
  "data-token-picker": "static-1.16341",
  "hub-http-contrib": "static-1.3006",
  "interframe": "static-3.4727",
  "tinymce-data": "static-1.40346",
  "tinymce-plugins": "static-1.57375",
  "ui-addon-sales-email": "static-1.5177",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5536",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3015",
  "content-assistance-lib": "static-1.7695",
  "dashboard-lib": "static-1.81386",
  "ExportDialog": "static-6.10359",
  "hubspot-prosemirror": "static-1.18140",
  "hubspot-prosemirror-plugins": "static-1.18132",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8663",
  "campaign-roi-lib": "static-1.8986",
  "feedback-loader": "static-1.29228",
  "apollo-link-hub-http": "static-2.4614",
  "hubspot-apollo-cache": "static-1.301",
  "purchase-motions-api": "static-1.5819",
  "trials-service-types": "static-1.3870",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.139",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1900",
  "growth-onboarding-next-action-components": "static-1.1844",
  "user-context-client": "static-1.4576",
  "idb-keyval": "static-1.43",
  "nest": "static-1.192",
  "reactive-lib": "static-1.687",
  "unified-auth-core-lib": "static-1.724",
  "getting-started-shared-tasks-store": "static-1.17518",
  "integrations-error-boundary-lib": "static-1.13419",
  "integrations-tracking-lib": "static-1.5565",
  "native-integrations-shared-strings": "static-1.7749",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10336",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.443",
  "calling-error-reporting": "static-1.31274",
  "shared-worker-versioning": "static-1.11003",
  "calling-usage-tracker": "static-1.6509",
  "voice-sms-access-library": "static-1.838",
  "customer-data-tracking": "static-1.6852",
  "commerce-permissions": "static-1.732",
  "products-iframe-lib": "static-1.7831",
  "products-ui-components-shared-msw-handlers": "static-1.10255",
  "location-customization-utils-lib": "static-1.9143",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4120",
  "video-components-external": "static-1.11148",
  "video-data-lib": "static-1.34806",
  "bend-plugin-pulse": "static-1.29",
  "directed-graph": "static-1.901",
  "event-emitter": "static-1.914",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.134",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9956",
  "fsm": "static-1.3697",
  "policy-lib": "static-1.6738",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10019",
  "navigation-messaging": "static-1.7236",
  "FileManagerLib": "static-1.39154",
  "NamespacedHubStyle": "static-2.9033",
  "FileManagerCore": "static-1.39013",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12372",
  "layout-dnd-utils": "static-1.11347",
  "react-codemirror": "static-1.10590",
  "ui-addon-emoji-picker": "static-1.9854",
  "ui-brand-identity-lib": "static-1.15109",
  "ui-addon-video-player": "static-1.8664",
  "ui-coaching-tips": "static-1.28444",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23432",
  "EmailSignatureEditor": "static-1.24290",
  "breeze-engine-lib": "static-1.487",
  "InboxConnectUtils": "static-4.14712",
  "universal-page-editor-lib": "static-1.2978",
  "google-sheets-integration-lib": "static-1.129",
  "microsoft-drive-integration-lib": "static-1.246",
  "calling-orchestration-schema": "static-1.35615",
  "sales-views-client-types": "static-1.4231",
  "crm-record-cards-service-types": "static-1.3579",
  "content-media-composition-data-lib": "static-1.12134",
  "content-media-compositions": "static-2.16141",
  "media-bridge-lib": "static-1.18863",
  "trellis-story-utils": "static-1.4481",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5860",
  "FileManagerImages": "static-1.36665",
  "video-components": "static-1.13151",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4497",
  "video-embed": "static-1.35640",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68328",
  "layout-data-lib": "static-1.9672",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6548",
  "commerce-tours-lib": "static-1.6024",
  "growth-onboarding-reliability": "static-1.5047",
  "sales-checkout-service-client": "static-1.3606",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21607",
  "sales-email-signature-service-client": "static-1.3810",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.21992",
  "outpost": "static-1.4151",
  "advanced-menus-core": "static-1.15070",
  "advanced-menus-lib": "static-1.12018",
  "ui-memberships-settings-lib": "static-1.33944",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15069",
  "simple-menus-lib": "static-1.16586"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34417",
  "client-types": "/client-types/static-1.464",
  "documents-lib": "/documents-lib/static-1.34422",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2098",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5558",
  "hs-test-utils": "/hs-test-utils/static-1.7981",
  "hub-http": "/hub-http/static-1.6187",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11427",
  "I18n": "/I18n/static-7.1615",
  "jasmine-immutable": "/jasmine-immutable/static-1.2985",
  "jasmine-runner": "/jasmine-runner/static-1.6433",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6973",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16634",
  "reporting-data": "/reporting-data/static-1.67373",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9306",
  "reporting-visualizations": "/reporting-visualizations/static-1.59449",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4734",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5038",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2464",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.782",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39629",
  "customer-data-objects": "/customer-data-objects/static-1.7629",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8049",
  "data-fetching-client": "/data-fetching-client/static-1.9638",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4483",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85740",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4685",
  "foundations-components": "/foundations-components/static-1.7857",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11735",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7124",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3812",
  "property-translator": "/property-translator/static-1.5367",
  "quartz-config": "/quartz-config/static-1.751",
  "quartz-core": "/quartz-core/static-1.6192",
  "quick-fetch": "/quick-fetch/static-1.3887",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5315",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8135",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8060",
  "report-customization-components": "/report-customization-components/static-1.13058",
  "reporting-enablement": "/reporting-enablement/static-1.22785",
  "reporting-reports": "/reporting-reports/static-1.67051",
  "reporting-snowflake": "/reporting-snowflake/static-1.55991",
  "reporting-ui-components": "/reporting-ui-components/static-2.64644",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4617",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8904",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9187",
  "sanitize": "/sanitize/static-1.4438",
  "sanitize-text": "/sanitize-text/static-1.8109",
  "self-service-api": "/self-service-api/static-1.10212",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1712",
  "signup-constants": "/signup-constants/static-1.18779",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20789",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8007",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4731",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10953",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11115",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9510",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17935",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10976",
  "ui-images": "/ui-images/static-2.1143",
  "UIComponents": "/UIComponents/static-3.8374",
  "usage-tracker": "/usage-tracker/static-1.7303",
  "usage-tracker-container": "/usage-tracker-container/static-1.7293",
  "usage-tracker-core": "/usage-tracker-core/static-1.7153",
  "usage-tracker-public": "/usage-tracker-public/static-1.7114",
  "viral-links-lib": "/viral-links-lib/static-1.7021",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3374",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3250",
  "quartz-webpack": "/quartz-webpack/static-1.3197",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8843",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4823",
  "foundations-theming": "/foundations-theming/static-1.4382",
  "quartz-auth": "/quartz-auth/static-1.648",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9015",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4989",
  "foundations-theming-base": "/foundations-theming-base/static-1.3367",
  "HeadJS": "/HeadJS/static-2.742",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3092",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.55",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4290",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.638",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7894",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3561",
  "persist-promise": "/persist-promise/static-1.3667",
  "quartz-i18n": "/quartz-i18n/static-1.648",
  "reporting-client-types": "/reporting-client-types/static-1.2481",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.882",
  "hs-story-utils": "/hs-story-utils/static-1.9394",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9873",
  "hubspotter-http": "/hubspotter-http/static-1.4623",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7215",
  "crm-message-bus": "/crm-message-bus/static-1.42893",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22064",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12991",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13126",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9793",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3980",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6751",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6846",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3811",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.944",
  "onboarding-tours": "/onboarding-tours/static-1.16527",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13566",
  "ui-addon-teams": "/ui-addon-teams/static-1.21498",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68253",
  "customer-data-properties": "/customer-data-properties/static-1.51421",
  "forms-ai-lib": "/forms-ai-lib/static-1.4258",
  "forms-utils-lib": "/forms-utils-lib/static-1.12509",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5340",
  "react-dnd-compat": "/react-dnd-compat/static-1.4585",
  "react-tinymce": "/react-tinymce/static-1.55135",
  "tinymce-config": "/tinymce-config/static-2.54261",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10314",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4126",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1744",
  "ui-fonts": "/ui-fonts/static-1.689",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.403",
  "quartz-test": "/quartz-test/static-1.648",
  "quartz-tracking": "/quartz-tracking/static-1.352",
  "batch-promise": "/batch-promise/static-1.1510",
  "external-options-client-types": "/external-options-client-types/static-1.4129",
  "react-colorpicker": "/react-colorpicker/static-2.10176",
  "copilot-toolkit": "/copilot-toolkit/static-1.11036",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12875",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6428",
  "reporting-action-components": "/reporting-action-components/static-1.41196",
  "reporting-filters": "/reporting-filters/static-1.238",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1634",
  "reporting-plugins": "/reporting-plugins/static-1.10255",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4221",
  "ui-addon-opt": "/ui-addon-opt/static-4.8336",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25269",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4842",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.27",
  "chirp-fetch": "/chirp-fetch/static-1.1851",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4139",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5816",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4049",
  "nested-table": "/nested-table/static-1.191",
  "timezone-utils": "/timezone-utils/static-2.5211",
  "bender-build-tools": "/bender-build-tools/static-1.3151",
  "chatspot-core": "/chatspot-core/static-1.21118",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2865",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9871",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3768",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4113",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3662",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18400",
  "growth-data-modal": "/growth-data-modal/static-1.5369",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3033",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1816",
  "navigation-components": "/navigation-components/static-1.17909",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4741",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.593",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10116",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7497",
  "ui-universal-auth": "/ui-universal-auth/static-1.8929",
  "user-context": "/user-context/static-1.5069",
  "cms-field-types": "/cms-field-types/static-1.4778",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "integrations-lib": "/integrations-lib/static-1.16004",
  "calling-global-api": "/calling-global-api/static-1.64384",
  "calling-internal-common": "/calling-internal-common/static-1.31268",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65766",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58060",
  "commerce-products-lib": "/commerce-products-lib/static-1.9406",
  "crm-links": "/crm-links/static-1.6250",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9200",
  "file-manager-components": "/file-manager-components/static-1.23514",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.115",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4194",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.598",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48613",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3936",
  "property-value-citations": "/property-value-citations/static-1.2035",
  "pulse": "/pulse/static-1.526",
  "smart-property-lib": "/smart-property-lib/static-1.6733",
  "tiered-pricing": "/tiered-pricing/static-1.1126",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9023",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19767",
  "tinymce-themes": "/tinymce-themes/static-1.56231",
  "data-token-picker": "/data-token-picker/static-1.16341",
  "hub-http-contrib": "/hub-http-contrib/static-1.3006",
  "interframe": "/interframe/static-3.4727",
  "tinymce-data": "/tinymce-data/static-1.40346",
  "tinymce-plugins": "/tinymce-plugins/static-1.57375",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5177",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3015",
  "content-assistance-lib": "/content-assistance-lib/static-1.7695",
  "dashboard-lib": "/dashboard-lib/static-1.81386",
  "ExportDialog": "/ExportDialog/static-6.10359",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18140",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18132",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8663",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8986",
  "feedback-loader": "/feedback-loader/static-1.29228",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4614",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.301",
  "purchase-motions-api": "/purchase-motions-api/static-1.5819",
  "trials-service-types": "/trials-service-types/static-1.3870",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.139",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1900",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1844",
  "user-context-client": "/user-context-client/static-1.4576",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.192",
  "reactive-lib": "/reactive-lib/static-1.687",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.724",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17518",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13419",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5565",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7749",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10336",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.443",
  "calling-error-reporting": "/calling-error-reporting/static-1.31274",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11003",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6509",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.838",
  "customer-data-tracking": "/customer-data-tracking/static-1.6852",
  "commerce-permissions": "/commerce-permissions/static-1.732",
  "products-iframe-lib": "/products-iframe-lib/static-1.7831",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10255",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9143",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4120",
  "video-components-external": "/video-components-external/static-1.11148",
  "video-data-lib": "/video-data-lib/static-1.34806",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.29",
  "directed-graph": "/directed-graph/static-1.901",
  "event-emitter": "/event-emitter/static-1.914",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.134",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9956",
  "fsm": "/fsm/static-1.3697",
  "policy-lib": "/policy-lib/static-1.6738",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10019",
  "navigation-messaging": "/navigation-messaging/static-1.7236",
  "FileManagerLib": "/FileManagerLib/static-1.39154",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9033",
  "FileManagerCore": "/FileManagerCore/static-1.39013",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12372",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11347",
  "react-codemirror": "/react-codemirror/static-1.10590",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9854",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15109",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8664",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28444",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23432",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24290",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.487",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14712",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2978",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.129",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.246",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35615",
  "sales-views-client-types": "/sales-views-client-types/static-1.4231",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3579",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12134",
  "content-media-compositions": "/content-media-compositions/static-2.16141",
  "media-bridge-lib": "/media-bridge-lib/static-1.18863",
  "trellis-story-utils": "/trellis-story-utils/static-1.4481",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5860",
  "FileManagerImages": "/FileManagerImages/static-1.36665",
  "video-components": "/video-components/static-1.13151",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4497",
  "video-embed": "/video-embed/static-1.35640",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68328",
  "layout-data-lib": "/layout-data-lib/static-1.9672",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6548",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6024",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5047",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3606",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21607",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3810",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.21992",
  "outpost": "/outpost/static-1.4151",
  "advanced-menus-core": "/advanced-menus-core/static-1.15070",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12018",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33944",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15069",
  "simple-menus-lib": "/simple-menus-lib/static-1.16586"
}
};
